import { getContent } from '../../../shared/content.js';
import { Blocks } from '../../components/RichText.js';
import { useHref, useLocale } from '../../i18n.js';

/**
 * The guides index.
 *
 * Its job is structural. Three use-case pages reachable only from the footer read as
 * three keyword landing pages that happen to share a call to action; the same three
 * behind a signposted section read as what they are. It carries no ad unit: an index page
 * is navigation, and Google's publisher policy is explicit about ads on screens with
 * little publisher content of their own.
 */

export function Guides() {
  const c = getContent(useLocale()).guides;
  const href = useHref();

  return (
    <section className="section">
      <div className="section__inner section__inner--narrow">
        <h1 className="section__title">{c.heading}</h1>
        <p className="section__lede">{c.lede}</p>

        <ul className="guide-list">
          {c.cards.map((card) => (
            <li key={card.href}>
              <a className="guide-card" href={href(card.href)}>
                <p className="guide-card__who">{card.forWho}</p>
                <h2 className="guide-card__title">{card.title}</h2>
                <p className="guide-card__body">{card.body}</p>
              </a>
            </li>
          ))}
        </ul>

        <div className="prose">
          <Blocks blocks={c.closing} />
        </div>
      </div>
    </section>
  );
}
